
const initialState = {
  logs: [],
  pagination: {},
};

export default function activityReducer(state = initialState, action) {
  switch (action.type) {
    case 'GET_ACTIVITY_LOGS':
      return {
        ...state,
        logs: action.payload,
        pagination: action.pagination,
      };
    default:
      return state;
  }
}
